import { NgModule } from '@angular/core';
import { NewLinePipe } from './newline.pipe';

@NgModule({
  declarations: [NewLinePipe],
  exports: [NewLinePipe],
})
export class NewLinePipeModule {}
